export const CONTENT_TYPE = Object.freeze({
  STYLEFRAME: 'STYLEFRAME',
  VIDEO_EMBED: 'VIDEO_EMBED',
  TEXT: 'TEXT',
});

export const PROJECTS_INFO = [
  // 2025 Reel
  {
    title: '2025 Reel',
    thumbnailTimeSeconds: 1,
    thumbnailURL:
      'https://res.cloudinary.com/du0rugjrg/video/upload/v1755226891/2025Reel2_ThumbnailVideo_ypde3b.mp4',
    description:
      'Some highlights from my work over the past couple of years. For more specific information on roles, see below.',
    Roles: {

    },
    detailsContent: [
      {
        contentType: CONTENT_TYPE.VIDEO_EMBED,
        vimeoID: '1104531613',
        width: 12, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: 'Roles',
        value:
          ':00 Pebbles - Personal Project/All Roles'
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          ':03 Bubba\'s LA Splash Animation - Art Director and Lead Artist'
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          ':05 Express Way Title Sequence - Lead Artist'
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          ':10 Glaringly Obvious - Personal Project/All Roles'
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          ':13 Nice Shot Title Sequence - Lead Artist'
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          ':16 Midas Tires - Lighting, Rendering, and Comp'
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          ':20 Bubba’s LA Logo Exploration - Lead Artist'
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          ':21 Bubba’s LA Catchphrase - Personal Project/All Roles'
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          ':24 Monopoly Go - Lighting, Rendering and Comp'
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          ':30 That Which We Left Behind - Personal Project/All Roles'
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          ':31 Big O Spot - Creative Development and Storyboarding'
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          ':34 Dexcom G7 - Storyboarding and 2D/3D Mograph'
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          ':39 Thorogood Boots - Text Animation'
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          ':45 Yerba Mate Spec Spot - Personal Project/All Roles'
      },
    ],
  },
  // Pebbles
  {
    title: 'Pebbles',
    thumbnailTimeSeconds: .5,
    thumbnailURL:
      'https://res.cloudinary.com/du0rugjrg/video/upload/v1754585964/PebbleSim_ThumbnailVideo_a4bc1n.mp4',
    description:
      'This was a fun personal project where I limited myself to working with only a black and white color pallete and forced myself to animate exclusively in Houdini, a tool I\'m continously amazed by in its depth (and difficulty).',
    Roles: {
      
    },
    detailsContent: [
      {
        contentType: CONTENT_TYPE.VIDEO_EMBED,
        vimeoID: '1106770141',
        width: 12, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754066369/StillSelect4_lr6gf8.png',
        width: 8, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        width: 4, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: '',
        width: 4, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754066368/StillSelect5_kv6ipc.png',
        width: 8,
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754066311/StillSelect3_adv6ue.png',
        width: 8,
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        width: 4, // accepts values from 1 to 12
      },
    ],
  },
  // Glaringly Obvious
  {
    title: 'Glaringly Obvious',
    thumbnailTimeSeconds: .5,
    thumbnailURL:
      'https://res.cloudinary.com/du0rugjrg/video/upload/v1760077187/GlaringlyObvious_HighBitrate_axarvm.mp4',
    description:
      'Another personal project I made exploring the concept of the limitless potential we all have located just behind our eyes. I experimented with a variety of textures and techniques, but I primarily wanted to work on my "fake 3D" skills in After effects and all the opportunities for textures that workflow provides. But of course, I also had to splash in a little real 3D in there.',
    Roles: {
      
    },
    detailsContent: [
      {
        contentType: CONTENT_TYPE.VIDEO_EMBED,
        vimeoID: '1126093679',
        width: 12, // accepts values from 1 to 12
      },
            {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: '',
        width: 10, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1760077216/GlaringlyObvious_styleframe06_mrbffu.png',
        width: 12, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: '',
        width: 2, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1760077216/GlaringlyObvious_styleframe01.1_l8n0ib.png',
        width: 8,
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        width: 2, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1760077217/GlaringlyObvious_styleframe04_h1n9xj.png',
        width: 6,
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1760077214/GlaringlyObvious_styleframe02_rnung2.png',
        width: 6, // accepts values from 1 to 12
      },
    ],
  },
  // Midas
  {
    title: 'Midas Tires',
    thumbnailTimeSeconds: 2,
    thumbnailURL:
      'https://res.cloudinary.com/du0rugjrg/video/upload/v1754585967/Midas_ThumbnailVideo_bgwblv.mp4',
    description:
      'Midas approached us to revamp their library of stills for marketing and storefront content. We were tasked with modeling, texturing, lighting, and rendering a suite of images of many of their tires in different poses. The stills had to be photoreal, but sleeker than their real world counterparts.',
    credits: {
      Client: 'Midas',
      creativeDirector: 'Ian Nelson',
      LightingAndComp: 'Ben Thomas',
      SnowVFX: 'Derek Kruk'
    },
    detailsContent: [

      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754066204/ManyTiresStills_mzcpej.png',
        width: 12, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1755276787/Encounter_1B_wk3car.png',
        width: 6, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754066205/Blizzak_4A_snow_select_n8y3nj.png',
        width: 6, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: 'The Process',
        value:
          'The team at Bubba’s was in charge of handling the whole 3D pipeline for this project. We started with real tires, all wheeled into our office and photographed. These references became models, which after meticulous review became Cinema 4D scenes that were finally rendered and brought into Photoshop to touch up. Some tires also got a snow treatment which was done through a simulation in Houdini, that was then also brought back into Cinema 4D.',
      },
      {
        contentType: CONTENT_TYPE.VIDEO_EMBED,
        vimeoID: '992379183',
        width: 10, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754066220/3A_wireframe2_fwsafc.png',
        width: 12, // accepts values from 1 to 12
      },
    ],
  },
    // Thorogood Boots
  {
    title: 'Thorogood Boots',
    thumbnailTimeSeconds: 2,
    thumbnailURL:
      'https://res.cloudinary.com/du0rugjrg/video/upload/v1754585965/ThorogoodBoots_ThumbnailVideo_ocl16b.mp4',
    description:
      'I worked closely with creative director Derek Kruk to concept, storyboard, and animate this piece showing off the durability of Thorogood Boots. While Derek did the 3D animation and simulations in Houdini, I created the text overlays that punctuate the piece.',
    credits: {
      Client: 'Thorogood Boots',
      creativeDirector: 'Derek Kruk and Ian Nelson',
      creativeConceptingAndStoryboards: 'Derek Kruk and Ben Thomas',
      Animation: 'Derek Kruk and Ben Thomas',
      DynamicsAndVFX: 'Derek Kruk',
    },
    detailsContent: [
     {
        contentType: CONTENT_TYPE.VIDEO_EMBED,
        vimeoID: '1106770241',
        width: 12, // accepts values from 1 to 12
      },
    ],
  },
  // TWWLB
  {
    title: 'That Which We Left Behind',
    thumbnailTimeSeconds: 1,
    thumbnailURL:
      'https://res.cloudinary.com/du0rugjrg/video/upload/v1754585965/ThatWhichWeLeftBehind_ThumbnailVideo_tipbmm.mp4',
    description:
      'That Which We Left Behind is a short film I made in college. It explores a long dead humanity\'s last testament to it\'s achievments; a museum made to last long past their own demise.',
    credits: {
      director: 'Ben Thomas',
    },
    detailsContent: [
      {
        contentType: CONTENT_TYPE.VIDEO_EMBED,
        vimeoID: '704725053',
        width: 12, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754157419/TWWLB_ProjectThumbnail_z5loyz.png',
        width: 12, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754157414/shot02still_mhrfbt.png',
        width: 12, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: '',
        width: 2,
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754157402/instaStill4_bmdcda.png',
        width: 10,
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754157399/instaStill3_f9rxyh.png',
        width: 10,
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: '',
        width: 2,
      },
    ],
  },
    // Express Way
  {
    title: 'The Express Way',
    thumbnailTimeSeconds: 2.25,
    thumbnailURL:
      'https://res.cloudinary.com/du0rugjrg/video/upload/v1754585963/ExpressWay_ThumbnailVideo_hgwxoi.mp4',
    description:
      'Over four years in the making, "The Express Way" evolved from an idea by director Danny Lee and the Hill power couple into a nationwide PBS series spotlighting artists\' unique stories and talents. Collaborating closely with Lee and Creative Director Ian Nelson, I designed an energetic main title that unfolds in vignette-style close-ups before revealing the full scope of the show\'s stories and featured artists.',
    credits: {
      client: 'PBS',
      director: 'Danny Lee',
      creativeDirector: 'Ian Nelson',
      DesignAndAnimation: 'Ben Thomas',
    },
    detailsContent: [
      {
        contentType: CONTENT_TYPE.VIDEO_EMBED,
        vimeoID: '1106770316',
        width: 12, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          '',
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: 'The Process',
        value:
          'This main title went through several iterations before becoming what it is now. We started basic, by filming real paint strokes on plexi glass that would eventually become the letters of the main title. This footage was then taken into After Effects, where a heavy amount of tweaking transformed the footage into animations that clips of the show could be seen through.',
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          '',
      },
      {
        contentType: CONTENT_TYPE.VIDEO_EMBED,
        vimeoID: '1104367823',
        width: 8, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754156778/ExpressWayIdeation_r9si8e.png',
        width: 7, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754156776/ExpressWay_MT_Storbyboards3.1_mdbjr6.png',
        width: 5,
      },
      
      
    ],
  },

  // Big Foot AT2/Legacy AS
  {
    title: 'Big O Tires',
    thumbnailTimeSeconds: 0.5,
    thumbnailURL:
      'https://res.cloudinary.com/du0rugjrg/video/upload/v1754585966/BigO_ThumbnailVideo_quuwd9.mp4',
    description:
      'I was tasked with creating a world where two of Big O\'s premiere tire varieties were rigourously tested and perfected, demonstrating their capability. I worked to concept, sketch, and model the various "testing stations" which I came up with as surreal abstractions of real tests tires went through to test their durability and longevity.',
    credits: {
      Client: 'Big O Tires',
      Agency: 'Barkley',
      creativeDirector: 'Ian Nelson',
      creativeConceptingAndStoryboards: 'Ben Thomas',
      Animation: 'Jory Federighi, Brian LeGoo, Erik Fashingbauer',
    },
    detailsContent: [
      {
        contentType: CONTENT_TYPE.VIDEO_EMBED,
        vimeoID: '1106766274',
        width: 12, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          'Below are some early renders from the concepting stage of this project',
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          '',
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754066109/Previs2_asrty8.png',
        width: 10, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: '',
        width: 2, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: '',
        width: 2, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754066106/Previs2_bw_fqakp4.png',
        width: 10,
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754066107/locationStyleframe_h9zxe8.png',
        width: 10,
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: '',
        width: 2, // accepts values from 1 to 12
      },
      
    ],
  },
  // Splash Animation
  {
    title: 'Bubba\'s LA Splash Animation',
    thumbnailTimeSeconds: 1.25,
    thumbnailURL:
      'https://res.cloudinary.com/du0rugjrg/video/upload/v1755277847/WebsiteSplashAnimation_03_uncompressed_udjwzl.mp4',
    description:
      'As a part of Bubba\'s LA\'s rebrand, I created a splash animation for the company website that demonstrated both the 2D and 3D capabilities of the studio as well as the fun, poppy new look the studio was donning.',
    credits: {
      studio: 'Bubba\'s LA',
      creativeDirector: 'Ian Nelson',
      DesignAndAnimation: 'Ben Thomas',
    },
    detailsContent: [
      {
        contentType: CONTENT_TYPE.VIDEO_EMBED,
        vimeoID: '1106771668',
        width: 12, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          '',
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: 'The Process',
        value:
          'I\'ve included below some early styleframes I made while still exploring the look the piece might take.',
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          '',
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754066455/WebsiteOpening_Styelframe_2_esdh9i.png',
        width: 6, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754066467/WebsiteOpening_Styelframe_1_jh6kem.png',
        width: 6,
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754066458/WebsiteOpening_Styelframe_5_jlswnh.png',
        width: 10,
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754066475/WebsiteOpening_Styelframe_9_iexmzv.png',
        width: 6, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754066477/WebsiteOpening_Styelframe_10_teh7ut.png',
        width: 6,
      },
      
    ],
  },
  // Monopoly Go
  {
    title: 'Monopoly Go',
    thumbnailTimeSeconds: 3.25,
    thumbnailURL:
      'https://res.cloudinary.com/du0rugjrg/video/upload/v1754585964/MonopolyGo_ThumbnailVideo_djy8j4.mp4',
    description:
      'Bubba\'s LA took on the task of creating three engaging social media spots for Monopoly Go, and it was an all hands on deck project. Specifically, I did on the animation and comp work on the "Its You" spot as well as the comp work across the other spots.',
    credits: {
      Client: 'Scopely',
      creativeDirector: 'Ian Nelson',
      characteranimation: 'Sikand Srinivas',
      Animation: 'Derek Kruk, and Ben Thomas',
      DynamicsAndSimulations: 'Derek Kruk',
      CompAndLighting: 'Ben Thomas, Derek Kruk, and Chris Kennedy'
    },
    detailsContent: [
      {
        contentType: CONTENT_TYPE.VIDEO_EMBED,
        vimeoID: '1106771964',
        width: 12, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.VIDEO_EMBED,
        vimeoID: '1106771907',
        width: 6, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.VIDEO_EMBED,
        vimeoID: '1106771932',
        width: 6, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754158092/MPY_Still5_egqzi6.png',
        width: 10,
      },
      
    ],
  },
    // Kinetic Type
  {
    title: 'Madness/Genius',
    thumbnailTimeSeconds: 3.15,
    thumbnailURL:
      'https://res.cloudinary.com/du0rugjrg/video/upload/v1755283301/RideTheLine2_ThumbnailVideo_pfnoya.mp4',
    description:
      'As a part of Bubba\'s LA\'s rebrand, I designed and animated a kinetic type treatment of the studio\'s catchphrase "Riding the line between madness and genius."',
    credits: {
      studio: 'Bubbas LA',
      creativeDirector: 'Ian Nelson',
      DesignAndAnimation: 'Ben Peterson'
      
    },
    detailsContent: [
      {
        contentType: CONTENT_TYPE.VIDEO_EMBED,
        vimeoID: '1106770278',
        width: 12, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          '',
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: 'The Process',
        value:
          'Below are some exploratory styleframes I designed while concepting the project (including my mispelling of "genious" which made it further into the creative process than I\'d like to admit).',
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          '',
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754066448/KineticTypography_2.1_hklzs3.png',
        width: 4, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754066444/KineticTypography_1.2_xv1kn5.png',
        width: 4,
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754066443/KineticTypography_1.1_vqrjyh.png',
        width: 4,
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754066441/KineticTypography_4_vubcbt.png',
        width: 6,
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754066434/KineticTypography_3.1_vxztpv.png',
        width: 6,
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          'More WIP styleframes and unused concepts that got left on the cutting room floor',
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          '',
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754066423/styleframe_Madness3_udlsvm.png',
        width: 6,
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754066421/styleframe_Madness2_esqpxf.png',
        width: 6,
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754066415/styleframe_Between2_eeafle.png',
        width: 12,
      },
      

    ],
  },
  // Yerba Matte
  {
    title: 'Yerba Matte',
    thumbnailTimeSeconds: 1.25,
    thumbnailURL:
      'https://res.cloudinary.com/du0rugjrg/video/upload/v1755215815/YerbaMate_ThumbnailVideo_i29lrk.mp4',
    description:
      'This is a personal project I made as an intern to practice my skills in product animation. I had a small hope it would one day get picked up by the drink brand Guayaki, but in the meantime enjoy the fake brand name can I designed.',
    roles: {
      
    },
    detailsContent: [
      {
        contentType: CONTENT_TYPE.VIDEO_EMBED,
        vimeoID: '992385020',
        width: 12, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754157702/yerb2_fscmvl.png',
        width: 6,
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754157694/yerb4_wgidxq.png',
        width: 6,
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754157698/yerb1_ivu22r.png',
        width: 12,
      },
      
    ],
  },
  // Dexcom
  {
    title: 'Dexcom G7',
    thumbnailTimeSeconds: 1,
    thumbnailURL:
      'https://res.cloudinary.com/du0rugjrg/video/upload/v1754585966/DexcomRealTime_ThumbnailVideo_vwmg72.mp4',
    description:
      'As a diabetic and user of the Dexcom G7, I felt a particular attachment to this project. I collaborated with other artists to storyboard, design, and animate several spots that demonstrate the comfort and quality of life improvements the Dexcom G7 brings to living with diabetes. ',
    credits: {
      Client: 'Dexcom',
      Agency: 'Calico',
      creativeDirector: 'Ian Nelson',
      StoryboardingAndDesign: 'Marcos Zanet and Ben Thomas',
      Animation: 'Marcos Zanet, Derek Kruk, and Ben Thomas',
    },
    detailsContent: [
      {
        contentType: CONTENT_TYPE.VIDEO_EMBED,
        vimeoID: '1106766249',
        width: 4, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754156884/dexcom5_sw5e79.png',
        width: 7,
      },
      {
        contentType: CONTENT_TYPE.VIDEO_EMBED,
        vimeoID: '1110361245',
        width: 10, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          '',
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: 'The Process',
        value:
          'Some fun BTS from the shoot day at the studio.',
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          '',
      },
      {
        contentType: CONTENT_TYPE.VIDEO_EMBED,
        vimeoID: '1110362036',
        width: 10, // accepts values from 1 to 12
      },
      
    ],
  },
    // Guilt
  {
    title: 'Guilt Title Sequence',
    thumbnailTimeSeconds: 1,
    thumbnailURL:
      'https://res.cloudinary.com/du0rugjrg/video/upload/v1754585963/Guilt_ThumbnailVideo_pe2ctc.mp4',
    description:
      'I worked closely with Denisz Akyurek to create an opening title for his film "Guilt" that captured the eerie, "what\'s in the shadows" feeling that constantly holds viewers on edge throughout the entire film as you explore the protagonist\'s descent into madness.',
    credits: {
      Director: 'Denisz Akyurek',
      creativeDirector: 'Ben Thomas',
      DesignAndAnimation: 'Ben Thomas',
    },
    detailsContent: [
      {
        contentType: CONTENT_TYPE.VIDEO_EMBED,
        vimeoID: '1106771175',
        width: 12, // accepts values from 1 to 12
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          '',
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: 'The Process',
        value:
          'Below are a few glimpses behind the scenes to lighting development and modeling the cramped basement room.',
      },
      {
        contentType: CONTENT_TYPE.TEXT,
        header: '',
        value:
          '',
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754157251/Guilt_EarlyLighting_angkya.png',
        width: 6,
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754157244/GuiltAltLighting2_bzhvkv.png',
        width: 6,
      },
      {
        contentType: CONTENT_TYPE.STYLEFRAME,
        url: 'https://res.cloudinary.com/du0rugjrg/image/upload/v1754157236/Guilt_Styleframe3_kkkn3q.png',
        width: 12,
      },
      
    ],
  },
];
